import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircleIcon } from '@heroicons/react/20/solid'
import logo from "../images/marriage.jpg";
import { useTranslation } from "react-i18next";
import { AppContext } from "../context/AppContext";
import ReCAPTCHA from "react-google-recaptcha";
import Cookies from 'js-cookie';
export default function EmailVerification() {
  const [verificationCode, setVerificationCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [resendStatus, setResendStatus] = useState(null);
  const [captchaValue, setcaptchaValue] = useState(null);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const { t } = useTranslation();
  const {
    siteKey,
  } = useContext(AppContext);

  const navigate = useNavigate();

  const handleResendCode = async (e) => {
    e.preventDefault();
  
    try {
      setLoading(true);
  
      if (isResendDisabled) {
        setLoading(false);
        return;
      }
  
      const Ruser = Cookies.get("Recentuser");
  
      const response = await fetch(`${process.env.REACT_APP_ADDRESS}/users/resendVerificationEmail/${Ruser}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (response.ok) {
        setLoading(false);
        setResendStatus(t('success'));
        setIsResendDisabled(true);

        setTimeout(() => {
          setIsResendDisabled(false);
        }, 60000); 
      } else {
        setLoading(false);
        setResendStatus(t('error'));
        setIsResendDisabled(false);
      }
    } catch (error) {
      setLoading(false);
      setError(t('Internal server error 😞'));
      setResendStatus(t('error'));
      setIsResendDisabled(false);
    }
  };
  
  const handleVerifyEmail = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      if (!verificationCode) {
        setLoading(false);
        setError(t('Please enter the verification code.'));
        return;
      }

      const Ruser = Cookies.get("Recentuser");

      const response = await fetch(`${process.env.REACT_APP_ADDRESS}/users/verifyEmail/${Ruser}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ verificationCode }),
      });

      if (response.ok) {
        setLoading(false);
        setSuccess(true);
      } else {
        setLoading(false);
        setError(t('Invalid verification code. Please try again.'));
      }
    } catch (error) {
      setLoading(false);
      setError(t('Internal server error 😞'));
    }
  };

  useEffect(() => {
    const errorTimeout = setTimeout(() => {
      setError(null);
    }, 2000);

    return () => clearTimeout(errorTimeout);
  }, [error, loading, success]);

  return (
    <>
      <div className="flex min-h-full flex-1">
        <div className="flex flex-1 flex-col justify-center px-4 py-5 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            {loading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-pink-600"></div>
              </div>
            ) : success ? (
              <div>
                <div className="text-green-600 font-semibold text-2xl text-center mb-8">
                  {t('Email Verified Successfully!')}
                </div>
                <button
                  onClick={() => navigate("/signin")}
                  className="flex w-full justify-center rounded-md bg-pink-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                >
                  {t('Proceed to Sign In.')}
                </button>
              </div>
            ) : error ? (
              <div className="text-red-600 font-semibold mb-4">{error}</div>
            ) : (
              <>
                {resendStatus === "success" && (
                  <div className="rounded-md bg-green-50 p-4 mb-4">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
                      </div>
                      <div className="ml-3">
                        <h3 className="text-sm font-medium text-green-800">{t('Code Resent Successfully!')}</h3>
                        <div className="mt-2 text-sm text-green-700">
                          <p>{t('The verification code has been resent to your email.')}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {resendStatus === "error" && (
                  <div className="text-red-600 font-semibold mb-4">{t('Error resending verification code. Please try again.')}</div>
                )}

                <div>
                  <h2 className="text-2xl font-bold leading-9 tracking-tight text-gray-900 mb-4">
                    {t('Verify your email, copy-paste the code sent to your email')}
                  </h2>
                </div>
                <div className="mt-0">
                  <form onSubmit={handleVerifyEmail} className="space-y-6">
                    <div>
                      <label
                        htmlFor="verificationCode"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        {t('Verification Code')}
                      </label>
                      <div className="mt-0">
                        <input
                          id="verificationCode"
                          name="verificationCode"
                          type="text"
                          autoComplete="off"
                          required
                          value={verificationCode}
                          onChange={(e) => setVerificationCode(e.target.value)}
                          className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>

                    <div>
                      <button
                        type="submit"
                        className="flex w-full justify-center rounded-md bg-pink-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                      >
                        {t('Verify Email')}
                      </button>
                    </div>
                  </form>
                </div>
                <div>
                        <ReCAPTCHA
                   sitekey={siteKey}
                          onChange={((val) => setcaptchaValue(val))}
                        />
                      </div>
                <div className="mt-6 text-center text-sm text-gray-500">
                  {t(`You didn't receive the code ?`)}{' '}
                  <button
                    onClick={handleResendCode}
                    disabled={isResendDisabled && !captchaValue}
                    className={`font-semibold leading-6 text-pink-600 hover:text-pink-500 ${
                      isResendDisabled ? 'cursor-not-allowed' : ''
                    }`}
                  >
                    {t('Resend Code')}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="relative hidden min-w-screen min-h-screen flex-1 lg:block">
          <img
            className="absolute inset-0 w-full h-full object-cover"
            src={logo}
            alt="img"
          />
        </div>
      </div>
    </>
  );
}
